<template>
  <div>
    <el-dialog title="审核操作" :visible.sync="dialogVisible" width="70%">
      <el-row>
        <el-col :span="3">
          <p>订单编号</p>
        </el-col>
        <el-col :span="21">
          <p>
            <span v-for="(item, index) in selectedItems" :key="index"
              >{{ item.applyNumber }}
              <span v-show="index !== selectedItems.length - 1">、</span>
            </span>
          </p>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="3">
          <p><span class="required-text">*</span>是否通过</p>
        </el-col>
        <el-col :span="21">
          <p class="approve-radio">
            <span
              @click="queryParams.approvalAction = '01'"
              :class="
                queryParams.approvalAction === '01' ? 'activate-approve' : ''
              "
            >
              <i></i>
              通过</span
            >
            <span
              @click="queryParams.approvalAction = '02'"
              :class="
                queryParams.approvalAction === '02' ? 'activate-approve' : ''
              "
            >
              <i></i>
              驳回</span
            >
          </p>
        </el-col>
      </el-row>

      <el-row class="remark">
        <el-col :span="3">理由：</el-col>
        <el-col :span="21">
          <el-input
            type="textarea"
            v-model="queryParams.approvalRemark"
            placeholder="请输入理由"
          ></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="btn-red"
          size="small"
          @click="getApproveResult()"
          :loading="loading"
          >确认</el-button
        >
        <el-button class="btn-red-plain" size="small" @click="close()"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'approve-dialog',
  data () {
    return {
      dialogVisible: false,
      loading: false,
      queryParams: {
        applyIds: [],
        approvalAction: '',
        approvalRemark: ''
      }
    }
  },
  props: {
    selectedItems: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created () {},
  methods: {
    show () {
      this.queryParams = this.$options.data().queryParams
      if (this.selectedItems) {
        this.selectedItems.forEach(item => {
          this.queryParams.applyIds.push(item.applyId)
        })
      }
      this.dialogVisible = true
    },
    check () {
      if (!this.queryParams.approvalAction) {
        this.$message.error('请选择审核结果')
        return false
      }
      return true
    },
    getApproveResult () {
      if (!this.check()) {
        return
      }
      let msg = this.queryParams.approvalAction === '01' ? '通过' : '驳回'
      this.$confirm('是否确认' + msg + '订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store
            .dispatch('getApplyApprove', this.queryParams)
            .then(res => {
              if (res.data.resultCode === '0') {
                this.$emit('success')
                this.$message.success('订单' + msg + '成功')
                this.dialogVisible = false
              }
              this.loading = false
            })
            .catch(() => {
              this.loading = false
              this.$message.success('订单' + msg + '失败')
            })
        })
        .catch(() => {})
    },
    close () {
      this.queryParams = this.$options.data().queryParams
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.approve-radio {
  span {
    cursor: pointer;
    margin-right: 30px;
    padding: 5px;
    i {
      height: 10px;
      width: 10px;
      border: 1px solid #ccc;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
  }
  .activate-approve {
    font-weight: 600;
    color: rgb(200, 16, 45);
    i {
      border-color: rgb(200, 16, 45);
      background: rgb(200, 16, 45);
    }
  }
}

.remark {
  padding: 15px 0;
}
</style>
